<script lang="ts">
	import BaseConditionNode from '../BaseConditionNode.svelte';
	import type { NodeData } from '../../types/flow-types';
	import {
		resolveFlowNodeTypeLabel,
		resolveSunConditionSummary,
	} from '../../helpers/flowNodeCardPresentation';

	export let id: string;
	export let data: NodeData;
	export let selected: boolean = false;
	export let validated: boolean = true;
	export let errors: string[] = [];

	$: displayText = resolveSunConditionSummary(data);
	$: nodeTypeLabel = resolveFlowNodeTypeLabel('sunriseSunsetCondition', data);
</script>

<BaseConditionNode
	{id}
	type="sunriseSunsetCondition"
	{data}
	{selected}
	{validated}
	{errors}
	cardTitle={displayText}
	{nodeTypeLabel}
	badge="Premium"
	{...$$restProps}
/>
